import { useEffect, useRef } from 'react'
import { animate, motion, useMotionValue, useTransform } from 'motion/react'

interface Props {
  value: number
  format?: (value: number) => string
  className?: string
}

/** Counts to a new value without re-rendering the surrounding panel. */
export function AnimatedNumber({ value, format = (n) => n.toFixed(0), className }: Props) {
  const motionValue = useMotionValue(value)
  const display = useTransform(motionValue, (latest) => format(latest))
  const first = useRef(true)

  useEffect(() => {
    if (first.current) {
      first.current = false
      motionValue.set(value)
      return
    }
    const controls = animate(motionValue, value, { duration: 0.42, ease: [0.22, 0.8, 0.25, 1] })
    return () => controls.stop()
  }, [motionValue, value])

  return <motion.span className={className}>{display}</motion.span>
}
